// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"582a61b2","239":"a73b80b2","455":"e58aa926"}[chunkId] + ".chunk.js";
};